import React from 'react'

import { PersonAvatar, WorkspaceLogo } from '@sketch/components'
import { WorkspaceInvitedNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper } from './AddShareMemberPreview.styles'
import {
  GoToWorkspaceAction,
  OpenWorkspaceInviteAction,
} from './InboxPreviewActions'
import {
  Card,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
  RoleBadge,
} from './TileCard.styles'

interface WorkspaceInvitedPreviewProps {
  notification: WorkspaceInvitedNotificationFragment
}

export const WorkspaceInvitedPreview = ({
  notification,
}: WorkspaceInvitedPreviewProps) => {
  const { user, workspace, title, membership, path } = notification

  const inviterName = user?.name ?? 'Someone'
  const inviterAvatar = user?.avatar?.small
  const workspaceName = workspace?.name ?? title
  const hasAccepted = Boolean(membership?.acceptedAt)

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {inviterAvatar ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={inviterName}
                src={inviterAvatar}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={inviterName} />
            )}
          </AvatarWrapper>
          <TileTitle>{inviterName}</TileTitle>
          <RoleBadge>Inviter</RoleBadge>
        </Tile>

        <Separator />

        <Tile>
          <AvatarWrapper>
            <WorkspaceLogo
              size="96px"
              workspaceName={workspaceName}
              src={workspace?.avatar?.small}
            />
          </AvatarWrapper>
          <TileTitle>{workspaceName}</TileTitle>
          <TileMeta>Workspace</TileMeta>
        </Tile>
      </TileWrapper>

      {hasAccepted && workspace ? (
        <GoToWorkspaceAction workspaceId={workspace.identifier} />
      ) : path ? (
        <OpenWorkspaceInviteAction path={path} />
      ) : null}
    </Card>
  )
}
